import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './app/App';
import { QueryClientProvider } from '@tanstack/react-query';
import './assets/fonts/fonts.css';
import { queryClient } from './api/query-client';
import theme from './theme';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { NotificationsProvider } from '@toolpad/core';
import {
  AuthContextProvider,
  GameSessionContextProvider,
  LoaderContextProvider,
} from './assets/context-providers';
import { GlobalStyles } from '@mui/styled-engine';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <QueryClientProvider client={queryClient}>
    <ThemeProvider theme={theme}>

      <LoaderContextProvider>
        <GameSessionContextProvider>
          <NotificationsProvider>
            <AuthContextProvider>
              <CssBaseline />
              <App />
              <GlobalStyles styles={{
                'html': {
                  backgroundColor: 'black',

                },
                'body': {
                  backgroundColor: '#F5F5F5',
                  aspectRatio: 9 / 16,
                  height: '100vh',
                  margin: 'auto',
                  minHeight: '1920px',
                },
                '#root': {
                  height: '100%',
                },
              }} />
            </AuthContextProvider>
          </NotificationsProvider>
        </GameSessionContextProvider>
      </LoaderContextProvider>
    </ThemeProvider>
  </QueryClientProvider>,
);
